<template>
  <div class="cat-scores-year-wrapper year-column"
    :class="numQuarters">
    <div 
      v-for="quarter in yearData.quarters"
      :key="quarter.quarter"
      class="quarter-column">
      <div class="map-score-block category-block">
        <color-block
        :score="quarter.categories[catIndex].score"
        :name="quarter.categories[catIndex].name"
        :ishovered="false">
        </color-block>
      </div>
    </div>
  </div>
</template>

<script>
import MapColorBlock from '../MapColorBlock';
import numQuarters from '../../helpers/numQuarters';

export default {
  name: 'cat-scores-year-column',
  props: ['catIndex', 'yearData'],
  components: {
    'color-block': MapColorBlock,
  },
  computed: {
    numQuarters,
  },
};
</script>

<style>
  
</style>



// WEBPACK FOOTER //
// CategoryScoresYearColumn.vue?00b77a8c